<template>
  <div>TrangTaoDanhMucHeThong</div>
</template>

<script>
export default {
  name: "TrangTaoDanhMucHeThong"
};
</script>


